import React from 'react';
import { PropTypes } from 'prop-types';
import './styles/FAQDrawer.css';
import { Button } from 'antd';

const FAQs = [
  {
    question: 'How do I update my profile?',
    answer:
      'You can update your profile by clicking the Edit Profile button on your profile page.',
  },
  {
    question: 'How do I change my password?',
    answer: 'Go to Settings to change your password.',
  },
  {
    question: 'How do I contact support?',
    answer: 'Click on the Help button or email support@example.com',
  },
  {
    question: 'How do I add a doctor to receive reports only?',
    answer:
      "Go to Staff, add the doctor's details, select the Report module, and submit. The doctor will get an email invitation to set a password and can then access only radiologist-submitted reports.",
  },
  {
    question: 'How do I add the accounting manager for payment emails?',
    answer:
      'In the Staff section, select the Account module when adding or editing the staff member.',
  },
  {
    question: 'How do I change my payment option?',
    answer:
      'Voxel offers Pay Now and Monthly Billing options. To switch between them, please contact info@voxelreaders.com',
  },
];

const FAQDrawer = ({ isOpen, onClose }) => {
  return (
    <>
      {isOpen && <div className="faq-backdrop" onClick={onClose}></div>}
      <div className={`faq-drawer ${isOpen ? 'open' : ''}`}>
        <div className="faq-drawer-header">
          <h4>Frequently Asked Questions</h4>
          <Button type="text" shape="circle" onClick={onClose}>
            <i className="fas fa-close"></i>
          </Button>
        </div>
        <div className="faq-drawer-content">
          <div className="faq-items-container">
            {FAQs.map((faq) => (
              <div className="faq-item" key={faq?.question}>
                <h5>{faq?.question}</h5>
                <p>{faq?.answer}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};
FAQDrawer.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};
export default FAQDrawer;
